import { render, staticRenderFns } from "./EScoreList.vue?vue&type=template&id=fcfa4e96&scoped=true"
import script from "./EScoreList.vue?vue&type=script&lang=js"
export * from "./EScoreList.vue?vue&type=script&lang=js"
import style0 from "./EScoreList.vue?vue&type=style&index=0&id=fcfa4e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfa4e96",
  null
  
)

export default component.exports